import { optional, withDependencies } from '@wix/thunderbolt-ioc'
import type { IPageServicesRegistrar } from '@wix/thunderbolt-symbols'
import { PageServicesManagerSymbol } from '@wix/thunderbolt-symbols'
import type { IPagesService } from '@wix/site-service-pages/definition'
import { PagesDefinition } from '@wix/site-service-pages/definition'
import type { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { name } from './symbols'
import type { SitePagesServiceEditorHandlers } from './types'

export const PagesServiceSideEffects = withDependencies(
	[optional(PageServicesManagerSymbol)],
	(
		servicesManagerGetter?: IPageServicesRegistrar
	): IModelUpdatesHandlersImplementor<SitePagesServiceEditorHandlers> => ({
		featureName: name,
		handlers: {
			updateConfig: (config) => {
				const servicesManager = servicesManagerGetter?.get()
				if (servicesManager?.hasService(PagesDefinition)) {
					const service = servicesManager.getService(PagesDefinition) as IPagesService
					service._updateConfig(config)
				}
			},
		},
	})
)
